import React from "react";
import { func, any } from "prop-types";
import FeatherIcon from "feather-icons-react";
import * as style from "../styles.module.scss";

const PayslipsProfileSection = ({ onAddOrUpdateHandler, payslipsSection }) => {
  return (
    <div
      className={`bg-white ${style.profile__admin} justify-content-between`}
      id="profilePayslipsSection"
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <FeatherIcon
          icon="file-text"
          size={30}
          style={{ minWidth: "fit-content" }}
        />
        <h2 className={style.profile__admin_title}>Payslips</h2>
        <span className={style.profile__admin_description}>
          View all of your payslips, P45s and P60s
        </span>
      </div>

      <span className="d-flex align-items-end">
        <button
          className={`btn btn-outline-info text-dark ${style.profile__admin_button}`}
          onClick={() => onAddOrUpdateHandler(payslipsSection.taskName)}
        >
          View payslips
        </button>
      </span>
    </div>
  );
};

PayslipsProfileSection.propTypes = {
  onAddOrUpdateHandler: func,
  payslipsSection: any,
};

export default PayslipsProfileSection;
